<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="documents"
      :items-per-page="10"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="{ 'items-per-page-text': 'Số Hồ Sơ một trang' }"
      v-bind="this.$attrs"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const originHeaders = [
  {
    text: 'STT',
    value: 'index',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Tên phòng thi',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Mã phòng thi',
    value: 'code',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Số lượng',
    value: 'capacity',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Địa điểm',
    value: 'location',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Môn',
    value: 'subjects',
    align: 'left',
    sortable: false,
    show: true
  }
]

export default {
  props: {
    documents: Array
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },

  methods: {}
}
/* eslint-enable no-unused-vars */
</script>
